fx.ns("models", class ThemeCategory extends fx.Model {

	constructor(data)
	{
		super(data);
	}

	get localized()
    {
        return true;
    }

});